import { Backdrop, Box, CircularProgress } from "@mui/material";
import { SpinnerIcon } from "../../styles/images";

export const LoadingSpinner = ({ loading }) => (
  <Backdrop open={loading} className="loadingSpinner">
    <Box className="logo">
      {/* <OspedaleIcon /> */}
      <SpinnerIcon />
    </Box>
    <CircularProgress size={220} />
  </Backdrop>
);
